import apiClient from "./apiService";

// Fetch dashboard data

export const fetchDashboard = async (page = 1) => {
  try {
    const response = await apiClient.get("/admin/dashboard", {
      params: { page },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
